module.exports = __webpack_public_path__ + "mainassets/img/arrow-right-dark.ce4e154a.svg";